import './RackPage.scss';
import { RackCard } from '../../components/RackCard/RackCard';
import products from '../../api/products';
import { CartridgesSlider } from '../../components/CartridgesSlider/CartridgesSlider';

export const RackPage = () => {

  const rackProducts = products.filter(product => (
    product.category === 'racks'
  ))

  const cartridgeProducts = products.filter(product => (
    product.category === 'cartridges'
  ));

  return (
    <section className="products">
      <div className="container">
        <div className="products__list">
          {rackProducts.map(rack => (
            <RackCard key={rack.id} product={rack} />
          ))}
        </div>
      </div>
      <CartridgesSlider cartridgeProducts={cartridgeProducts} />
    </section>
  );
};